import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      if (attempts > 12) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (e) { console.debug("payment status not ready, retrying", e?.message); }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F9F8F6]">
      <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-8 text-center">
        {status === "checking" && <><Loader2 className="w-12 h-12 animate-spin text-slate-400 mx-auto mb-4" /><p className="text-slate-600">Confirmando seu pagamento...</p></>}
        {status === "paid" && <><CheckCircle2 className="w-16 h-16 text-green-600 mx-auto mb-4" /><h1 className="font-display text-3xl font-black text-slate-900">Pagamento confirmado!</h1><p className="text-slate-500 mt-2">Sua dívida foi quitada. Obrigado!</p></>}
        {(status === "error" || status === "timeout") && <><XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" /><h1 className="font-display text-2xl font-black text-slate-900">Não conseguimos confirmar</h1><p className="text-slate-500 mt-2">Se o valor foi cobrado, aguarde alguns instantes e atualize a página.</p></>}
      </div>
    </div>
  );
}
